import { useApp } from "@/context/AppContext";

const actionBtn =
  "px-2.5 py-1.5 border border-border rounded-default bg-transparent text-text2 text-xs cursor-pointer flex items-center gap-1 transition-colors font-normal hover:border-accent hover:text-text hover:bg-bg3";

export function Process() {
  const { setCurrentView, authRole, impersonatedRole } = useApp();
  const isAdmin = authRole === "admin" && !impersonatedRole;

  return (
    <div className="flex-1 px-7 py-6 overflow-y-auto" data-testid="process-view">
      <h1 className="text-xl font-semibold text-text mb-4">Projects &amp; Process</h1>
      <div className="bg-bg2 border border-border rounded-default p-5 mb-4">
        <h2 className="text-sm font-semibold text-text mb-2">Actions</h2>
        <div className="flex flex-col gap-2 mt-3">
          <button className={actionBtn} onClick={() => setCurrentView("source-management" as any)}>Source management</button>
          <button className={actionBtn}>Import/export requirements</button>
          <button className={actionBtn}>Manage projects</button>
          {isAdmin && (
            <button className={actionBtn} onClick={() => setCurrentView("audit-log" as any)}>Audit log report</button>
          )}
          <button className={actionBtn}>Jira sync</button>
        </div>
      </div>
    </div>
  );
}
